import { render } from "./ProjectDeleteInfo.vue?vue&type=template&id=4c379362"
import script from "./ProjectDeleteInfo.vue?vue&type=script&lang=js"
export * from "./ProjectDeleteInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__